import { useState, useEffect, useLayoutEffect, useContext } from "react";
import { AppContext } from "../App";

export default function useJobCode() {
  const { location } = useContext(AppContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [jobCode, setJobCode] = useState("NP-UK-Bun-0004");

  useLayoutEffect(() => {
    const hcpPopup = document.querySelector(".hcp-popup-header");

    if (hcpPopup) {
      setPopupVisible(true);
    } else {
      setPopupVisible(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (popupVisible) {
      setJobCode("NP-UK-Bun-0069");
    } else {
      switch (location.pathname) {
        case "/hcp":
        case "/hcp/":
          setJobCode("PP-UK-Bun-0212");
          break;
        case "/par/":
          setJobCode("NP-UK-Bun-0041");
          break;
        case "/hcp/initiating-bunov":
          setJobCode("PP-UK-Bun-0213");
          break;
        case "/hcp/resources":
          setJobCode("PP-UK-Bun-0214");
          break;
        case "/hcp/contact-us":
          setJobCode("PP-UK-Bun-0215");
          break;
        case "/hcp/pi":
          setJobCode("PP-UK-Bun-0156");
          break;
        case "/patient/":
        case "/patient":
          setJobCode("NP-UK-Bun-0073");
          break;
        case "/patient/how-to-apply-bunov":
          setJobCode("NP-UK-Bun-0074");
          break;
        case "/patient/side-effects":
          setJobCode("NP-UK-Bun-0076");
          break;
        case "/patient/useful-resources":
          setJobCode("NP-UK-Bun-0044");
          break;
        case "/patient/why-have-i-been-prescribed-bunov":
          setJobCode("NP-UK-Bun-0075");
          break;
        default:
          setJobCode("NP-UK-Bun-0014");
          break;
      }
    }
  }, [popupVisible, location.pathname]);

  return jobCode;
}
